<template>
  <!-- 栅格组件
      @author: 王汝鹏
      @date: 2019-9-10
   -->
  <el-row v-bind="{
            align:gridAlign, 
            gutter:gridGutter, 
            justify:gridJustify
          }"
          class="form-grid" 
          :style="{'padding-left': paddingLeft}"
          type="flex">
    <el-col v-for="(col, colIndex) in formNode.children" :key="colIndex"
            :span="formMap[col.id].baseOption.span ? formMap[col.id].baseOption.span : 0"
            class="form-grid_col">
      <draggable v-model="col.children"
                 :value="col.children"
                 @input="(v) => col.children=v.filter(i=>i)"
                 @add="(e) => handleAddFormItem(e, col.children)"
                 class="form-grid_draggable"
                 :options="{group: {name:'grid_wrap', put:onPut},
                            handle:'.drag-bar', ghostClass:'draggable-status_ghost'}">
        <form-item-template v-for="(el) in col.children" 
                            :key="el.id" 
                            :formNode="el"
                            :formParent="col.children"
                            :class="el.type">
        </form-item-template>
      </draggable>
    </el-col>
  </el-row>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 编辑组件项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  components: { Draggable: require('vuedraggable') },
  mixins: [ mixFormItemTemplateChild ],
  methods: {
    /** @name 栅格组件不可以嵌套【自由面板】
     *  @param {Object} sortable1 来源sortable对象
     *  @param {Object} sortable2 放入sortable对象
     *  @param {Object} el 拖拽元素
     *  @param {Object} e 拖拽事件对象
     *  @return {Boolean} {true:可以放入，false:不允许放入}
     *  @author 王汝鹏
     *  @version 2019-11-26
     */
    onPut(sortable1, sortable2, el, e) {
      let elClassList = [...el.classList];
      switch(true) {
        case elClassList.includes("free"): return false;
        default: return true;
      }
    },
    /** @name 添加表单项
     *  @description 设置新表单项为激活状态，通过新表单项索引找到元素更新为激活项
     *  @param {Object} e
     *  - {Number} newIndex 表单项拖拽进来的索引位置
     *  - {Element} item 拖拽的元素对象
     *  @param {Array} formList 激活表单项父级
     *  @author 王汝鹏
     *  @version 2019-09-22
     */ 
    handleAddFormItem({newIndex, item}, formList) {
      // 模块组件拖拽
      if (item.className.indexOf("domain-component-item") !== -1) { return; }
      // 设置激活项
      let formNode = formList[newIndex];
      this.formListManager().activeNode(formNode, formList);
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemGrid.vue